import colorPalette from '../color-palette';

const { primary } = colorPalette;

export default {
  MuiFormControlLabel: {
    root: {
      '& p': {
        marginBottom: '4px',
      },
      '&.Mui-disabled': {
        color: primary.mainDisabled,
        opacity: 0.5,
      },
    },
  },
};
